<template>
    <div>
       <new-text style="margin-bottom: 20px" :text="text"></new-text>
       <div class="summary_table">
         <div class="tr">
            <div class="th">总评项目</div>
            <div class="th">本次检测</div>
            <div class="th">上次检测</div>
         </div>
         <div class="tr" v-for="(item,index) in risklist" :key="index">
            <div class="td">{{item.title}}</div>
            <div class="td"><em>{{item.on_time}}</em><span v-if="index<3">{{item.functional_status}}</span></div>
            <div class="td"><em>{{item.last_time}}</em><span v-if="index<3">{{item.last_time_value}}</span></div>
         </div>
       </div>
       <div class="sum_title">免疫风险说明</div>
        <div class="risk" v-for="(item,index) in risklist" :key="index">
          <div class="risk_top">
              <div>
              <img :src="require('../assets/image/icon'+item.icon+'.png')">
              <span>{{item.title}}</span>
              </div>
              <div v-if='item.title == "免疫风险" || item.title =="精神压力" || item.title =="精神状态" || item.title=="健康风险"' class="risk_status">
                <LevelBar :active-index="item.status"/>
              </div>
              <div v-if='item.title == "机能水平"' class="risk_status_two">
                <LevelBar :active-index="item.status" :data-list="jnstatuslist"/>
              </div>
              <div v-if='item.title == "耗氧率"' class="risk_status_two">
                <LevelBar :active-index="item.status" :data-list="O2statuslist"/>
              </div>
              <div v-if='item.title == "抗氧化能力"' class="risk_status_two">
                <LevelBar :active-index="item.status" :data-list="O222statuslist"/>
              </div>
              <div v-if='item.title == "自主神经功能"' class="zizhuStatus">
                <div :class=" 'active'+item.status " >{{item.on_time}}</div>
              </div>
              <div v-if='item.signs' class="risk_signs">
              {{item.signs}}
              </div>
          </div>
          <div v-show="item.showCon" class="risk_cont">
              <div class="red_title">名词解释</div>
              <template v-if="item.descArr">
                <div v-for="(desc,descind) in item.descArr" :key="descind">{{desc}}</div>
              </template>
              <div v-if="!item.descArr">{{item.desc}}</div>
              <div v-if="item.result" class="red_title">本次结果 【{{item.functional_status}}】</div>
              <div>{{item.result}}</div>
          </div>
          <div 
              v-if="item.desc || item.result"
              class="risk_btn"
              @click="handleContent(item,index)"
              >{{item.btntxt}}
              <img :class="item.showCon ? 'rotates' : ''" src="../assets/image/down.png" />
          </div>
      </div>
    </div>
</template>
<script>
import NewText from "./NewText"
import LevelBar from "./LevelBar"
export default {
    props:['list'],
    components:{ NewText, LevelBar },
    data(){
        return{
           jnstatuslist:[
              {name:'高',id: 5},
              {name:'偏高           ',id: 4},
              {name:'中',id: 3},
              {name:'偏低',id: 2},
              {name:'低',id: 1},], //耗氧量风险状态
           O2statuslist:[
              {name:'优秀',id: 5},
              {name:'良好',id: 4},
              {name:'正常',id: 3},
              {name:'偏差',id: 2},
              {name:'差',id: 1},], //耗氧量风险状态
           O222statuslist:[
                {name:'优秀',id:5},
                {name:'良好',id:4},
                {name:'正常',id:3},
                {name:'偏弱',id:2},
                {name:'弱',id:1},
                ], //抗氧化风险状态
           risklist:this.list,
           text: '以下6项指标是对免疫力的综合性评价，需注意：当机能水平＜60，同时自主神经失调或中度兴奋，这类人群通常睡眠质量较差、睡眠时间不足，长期保持这种状态，免疫力会下降，同时容易存在精神压力等级升高，抗氧化能力（抗衰老能力）、耗氧率也会变差，总体的健康风险也会升高。'
        }
    },
    watch:{
      list(newVal){
        console.log('list的值改变啦啦啦啦啦啦啦')
        this.risklist = newVal;
        console.log(this.risklist);
      }
    },
    methods:{
       handleContent(e,i){
         console.log('asdf',i)
         let risklist = this.risklist;
         if(risklist[i].showCon){
            risklist[i].btntxt = '查看建议'
         }else{
            risklist[i].btntxt = '收起'
         }
         risklist[i].showCon = !risklist[i].showCon
         console.log('risklist[i].showCon',risklist[i].showCon)
         this.risklist = risklist
       }
    },
    created(){

    }
}
</script>
<style lang="scss" scoped>
.summary_table{
  width: 700px;
  margin: auto;
  border-radius: 5px;
  overflow: hidden;
  font-size: 28px;
}
.summary_table .tr{
  display: flex;
  justify-content: space-between;

}
.summary_table .tr .th{
  background-color: #2E94E5;
  flex: 1;
  text-align: center;
  color: #fff;
  height: 68px;
  line-height: 68px;
  border: 1px solid #ddd;
  border-bottom: none;
  box-sizing: border-box;
}
.summary_table .tr .th:nth-child(2){
  border-left: none;
  border-right: none;
}
.summary_table .tr .td{
  text-align: center;
  flex: 1;
  background-color: #fff;
  border: 1px solid #ddd;
  border-top: none;
  height: 68px;
  line-height: 68px;
}
.summary_table .tr .td span{
  margin-left: 10px;
}
.summary_table .tr .td em{
  display: inline-block;
  min-width: 80px;
  font-style: normal;
}

.summary_table .tr .lasttd em{
  width: 100%;
}
.summary_table .tr .td:nth-child(2){
  border-left: none;
  border-right: none;
}
/* 风险说明 */
.sum_title{
  margin:25px;
  color: #2E94E5;
  border-left: 3px solid #2E94E5;
  padding-left: 12px;
  font-size: 30px;
  height: 40px;
  line-height: 40px;
  text-align: left;
}
.risk{
  background-color: #fff;
  padding: 0 25px;
  margin: 0 auto 20px;
  width: 650px;
}
.risk_top{
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ddd;
  padding: 30px 0;
  font-size: 34px;
}
.risk_top>div:first-child{
  display: flex;
  align-items: center;
}
.risk_top img{
  width: 42px;
  height: 42px;
  vertical-align: middle;
  margin-right: 16px;
}
.risk_status,.risk_status_two,.risk_status_three{
  width: 350px;
  >div{
    width: 350px;
  }
}
// .risk_status div,.risk_status_two div ,.risk_status_three div{
//   width: 68px;
//   height: 40px;
//   line-height: 40px;
//   color: #fff;
//   background-color: #B5B5B5;
//   border-left: 1px solid #fff;
//   font-size: 24px;
//   text-align: center;
// }
.risk_status div:nth-child(1).active{
  background-color: #009944;
}
.risk_status div:nth-child(2).active{
  background-color: #F9C75E;
}
.risk_status div:nth-child(3).active{
  background-color: #EB6100;
}
.risk_status div:nth-child(4).active{
  background-color: #DD352A;
}
.risk_status div:nth-child(5).active{
  background-color: #A01D18;
}
.risk_status_two div:nth-child(1).active{
  background-color: rgb(39,174,246);
}
.risk_status_two div:nth-child(2).active{
  background-color: rgb(40,102,247);
}
.risk_status_two div:nth-child(3).active{
  background-color: #009944;
}
.risk_status_two div:nth-child(4).active{
  background-color: #009944;
}
.risk_status_two div:nth-child(5).active{
  background-color: #009944;
}
.risk_signs{
  background-color: #EB6100;
  color: #fff;
  padding: 8px 10px;
  font-size: 25px;
}
.risk_cont{
  font-size: 30px;
  color: #616161;
  padding: 10px 0 25px;
  border-bottom: 1px solid #ddd;
  text-align: left;
}
.red_title{
  font-size: 30px;
  color: #D30909;
  margin: 25px 0 5px;
  font-weight: bold;
}
.risk_btn{
  font-size: 30px;
  color: #949494;
  padding: 25px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.risk_btn img{
  width: 21px;
  height: 11px;
  margin-left: 5px;
}
.risk_btn img.rotates{
  transform: rotate(180deg);
}
.zizhuStatus div{
  color: #fff;
  padding:6px 10px;
  border-radius: 5px;
  font-size: 24px;
}
.zizhuStatus .active1{
  background-color: rgb(39,174,246);
}
.zizhuStatus .active2{
  background-color: rgb(40,102,247);
}
.zizhuStatus .active3{
  background-color: #EB6100;
}
.zizhuStatus .active4{
  background-color: #A01D18;
}
.zizhuStatus .active5{
  background-color: #9E13F6;
}
.zizhuStatus .active6{
  background-color: #009944;
}
</style>